import { all, select, takeEvery, fork, call, put } from 'redux-saga/effects'

// action
import { i18nActions } from '@redux/store/index'

// api
import { i18nApi, ResType } from '@api'

// lib
import { Logger } from '@utils'

// stype
import { I18nType } from '@schemas'

const apiUpdateI18n = async (paramsId: string, body: any) => {
	const res: ResType | undefined = await i18nApi.updateI18n({
		params: { id: paramsId },
		body: body,
	})
	return res
}

function* updateI18n() {
	try {
		const i18n: I18nType = yield select(state => state.i18n.updateI18n)

		const body = {
			tableName: i18n.tableName,
			tableId: i18n.tableId,
			menuId: i18n.menuId,
			isoLanguageCode: i18n.isoLanguageCode,
			value: i18n.value,
			title: i18n.title,
		}

		yield call(apiUpdateI18n, i18n.id, body)
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(i18nActions.UPDATE_I18N, updateI18n)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
